// ** Store Imports
import { handleNavbarType } from "@src/redux/layout";
import type { RootState } from "@src/redux/store";

import { useSelector } from "react-redux";
import { useAppDispatch } from "@src/redux/hooks";

export const useNavbarType = () => {
  // ** Hooks
  const dispatch = useAppDispatch();
  const store = useSelector((state: RootState) => state.layout);

  const setNavbarType = (type: any) => {
    dispatch(handleNavbarType(type));
  };

  return { navbarType: store.navbarType, setNavbarType };
};
